import React from "react";
import { SpendableDetails } from "../interfaces/SpendableDetails";
import { SpendingOnType } from "../interfaces/SpendablesForModules";
import ButtonCell from "./buttons/ButtonCell";
import Drawer from "./Drawer";
import SpendImprovementForm from "./SpendImprovementForm";
import SpendImprovementFormForXP from "./SpendImprovementFormForXP";

interface Props {
  moduleKey: string;
  spendableDetails: SpendableDetails;
  spendingOn: SpendingOnType;
  i: number;
}

export default ({ moduleKey, spendableDetails, spendingOn, i }: Props) => {
  const [open, setOpen] = React.useState<boolean>(false);
  let form = null;
  switch (spendingOn) {
    case SpendingOnType.RULES:
      form = <SpendImprovementForm />;
      break;
    case SpendingOnType.STATS:
      form = null;
      break;
    case SpendingOnType.XP:
      form = <SpendImprovementFormForXP xpModuleKey={moduleKey} />;
      break;
  }
  return (
    <>
      <ButtonCell
        buttonText={`Use ${spendableDetails.name}`}
        dataTest={`use-for-${moduleKey}-${spendableDetails.type}-${i}`}
        classes="grid-cell-fill"
        infoSize={true}
        onClick={() => setOpen(true)}
      />
      {form}
      <Drawer DrawerProps={{ open, onClose: () => setOpen(false) }}></Drawer>
    </>
  );
};
